import { StyledSelect } from '@/shared/styles';
import { useFeatureStore } from '@/stores/FeatureStore/FeatureStore';
import { Form } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FeatureSelectProps } from './FeatureSelect.consts';
import { CreateTrustedSourceFeatureDto, FeatureCode } from '@user1st/api-client';
import { FeatureLimitGroup } from '../FeatureLimit/FeatureLimitGroup';

export const FeatureSelect: React.FC<FeatureSelectProps> = ({
  name,
  selected,
}: FeatureSelectProps) => {
  const { features, fetchFeatures } = useFeatureStore();
  const { t } = useTranslation();
  const [selectedFeatures, setSelectedFeatures] = useState<CreateTrustedSourceFeatureDto[]>([]);

  const handleFeaturesChange = (values: FeatureCode[]) => {
    const result: CreateTrustedSourceFeatureDto[] = [];

    for (const value of values) {
      const exists = selectedFeatures.find((feature) => feature.code === value);

      if (exists) {
        result.push(exists);
      } else {
        result.push({ code: value });
      }
    }

    setSelectedFeatures(result);
  };

  useEffect(() => {
    if (selected) {
      setSelectedFeatures(
        selected.map((item) => ({
          ...item,
          code: item.code,
        }))
      );
    }
  }, [selected]);

  useEffect(() => {
    fetchFeatures();
  }, []);

  return (
    <>
      <Form.Item name={name}>
        <StyledSelect
          mode="tags"
          placeholder={t('admin.form.features')}
          tokenSeparators={[',']}
          options={features.map((feature) => ({
            label: feature.name,
            value: feature.code,
          }))}
          onChange={(value) => handleFeaturesChange(value as FeatureCode[])}
        />
      </Form.Item>

      {selectedFeatures.map((selectedFeature) => {
        const feature = features.find((feature) => feature.code === selectedFeature.code);

        return (
          <FeatureLimitGroup
            key={selectedFeature.code}
            code={selectedFeature.code}
            name={feature?.name ?? t('admin.form.unknown')}
            parameterName="featuresLimits"
          />
        );
      })}
    </>
  );
};
